import config from 'root/../config';
import authConfig from './../scenes/Authentication/moduleConfig';
import userService from 'services/userService';
import languageService from 'services/languageService';

const request = require('superagent');

const authService = {
    logIn: ({username, password, token,type}) => {

        let queryObject = {};
        let url = "";
        if (typeof token != 'undefined') {
            queryObject = {
                token: token,
                type: type,
            }
            url = authConfig.APIs.authenticateExternal;
        } else {
            queryObject = {
                username: username,
                password: password,
            }
            url = authConfig.APIs.authenticate;
        }

        let authReq = request.post(config.apiAppUrl + url)
            .accept('application/json')
            .send(queryObject)

        let resolveAuth;
        let rejectAuth;
        let authPromise = new Promise((resolve, reject) => {
            resolveAuth = resolve;
            rejectAuth = reject;
        })

        authReq.then((data)=>{
            authService.setToken(data.body.AUTH_TOKEN);

            userService.populateUserDetails(authService.context,()=>{
                resolveAuth();
                authService.context.set('showCurrentPortalInfo', true);
            }).catch(error => {
                rejectAuth({"MESSAGE":[{"MESSAGE":"Unable to authenticate.","TYPE":"error","TAG":""}]});
            });  
        }).catch(e => {
            rejectAuth(e.response.body);
            return e;
        });

        return authPromise;
    },
    authenticateWithExternalId : ({token,errorMessage}) => {
        let resolveAuth;
        let rejectAuth;
        let externalPromise = new Promise((resolve, reject) => {
            resolveAuth = resolve;
            rejectAuth = reject;
        })

        if(typeof errorMessage != 'undefined')
            rejectAuth(errorMessage)
        else{
            authService.setToken(token);
            userService.populateUserDetails(authService.context,()=>{
                resolveAuth()
                authService.context.set('showCurrentPortalInfo', true);
            }).catch(e => {
                rejectAuth(e.response.body)
            });  
        }
        return externalPromise;
    },
    logOut: () => {
        const defaultLanguage = languageService.getDefaultLanguage();
        const languageSettings = languageService.getLanguageSettingsByCode(defaultLanguage);
        languageService.changeLanguage(languageSettings,false);
        request('POST', config.apiAppUrl + authConfig.APIs.logout)
            .accept('text/html')
            .send({
                auth_token: authService.getToken(),
            })
            .then(()=>{
                window.location.reload();
            });
            window.localStorage.removeItem('auth_token');
        return true;
    },
    isLoggedIn: () => {
        if (window.localStorage.getItem('auth_token') !== null) {
            return true;
        } else {
            return false;
        }
    },
    getToken: () => {
        return window.localStorage.getItem('auth_token');
    },
    setToken: (token) => {
        window.localStorage.setItem('auth_token', token);
    },
    setContext: (AppContext) => {
        authService.context = AppContext;
    },
    context: {},
}

export default authService;